module.exports = __webpack_public_path__ + "img/about.c923ba33.jpg";